// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__fTQzP","sideSprite":"style__sideSprite__SVQFa","middleSprite":"style__middleSprite__ct+Mg"};